<template>
  <v-form
    ref="carPlate"
    v-model="isValid"
    class="d-flex flex-column align-center justify-center"
  >
    <div class="question-text mb-2 d-flex align-center">
      <div>
        {{ question.text }}
      </div>
      <v-tooltip
        v-if="question.tooltip"
        :attach="true"
        top
        max-width="300"
        color="rgb(0, 0, 0)"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            small
            class="ml-3"
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
          >
            mdi-information-outline
          </v-icon>
        </template>
        <span>{{ question.tooltip }}</span>
      </v-tooltip>
    </div>
    <div>
      <v-combobox
        v-model="answer"
        :items="items"
        :attach="true"
        :menu-props="{
          allowOverflow: true
        }"
        :return-object="false"
        dense
        filled
        rounded
        solo
        flat
        class="dropdown-input"
        item-text="name"
        item-value="name"
        hide-details
        @change="selectAnswer"
      >
        <template v-slot:item="{ index, item }">
          <div class="d-flex align-center">
            <!--            <v-avatar-->
            <!--              size="22px"-->
            <!--              class="mr-5"-->
            <!--            >-->
            <!--              <img-->
            <!--                v-if="item.logo"-->
            <!--                :src="item.logo"-->
            <!--                alt="Car logo"-->
            <!--              />-->
            <!--              <v-icon>-->
            <!--                {{ item.name.substring(2) }}-->
            <!--              </v-icon>-->
            <!--            </v-avatar>-->
            <div>
              {{ item.name }}
            </div>
          </div>
        </template>
      </v-combobox>
    </div>
  </v-form>
</template>

<script>
import { brands } from '@/_utils/car-brands';

export default {
  name: 'CarQuestionAutocomplete',
  props: {
    question: {
      type: Object,
      required: true
    },
    currentAnswer: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      answer: '',
      isValid: true
    };
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.width < 961;
    },
    items() {
      return brands;
    }
  },
  methods: {
    selectAnswer() {
      const selected = {
        id: -1,
        text: this.answer,
        isValid: this.isValid,
        multipleParentId: this.question.multipleParentId
      };
      if (this.answer) {
        selected.questionId = this.question.id;
        selected.questionText = this.question.text;
        this.$emit('updateAnswer', selected);
      }
    }
  }
};
</script>

<style scoped>
.question-text {
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}
.dropdown-input {
  border-radius: 4px !important;
  width: 355px;
}
.dropdown-input ::v-deep .v-select__slot input {
  border: none !important;
}
@media screen and (max-width: 600px) {
  .dropdown-input {
    width: 100%;
    min-width: 260px;
  }
}
</style>
